import { makeStyles } from '@material-ui/core/styles'
import { getPixelInREM } from '../../common/material'

// MATERIAL: remove these colors when material theme is cleaned up
const $grayBackgroundDarkOpaque = 'rgba(35, 31, 32, 0.09)'
const $grayBackgroundLightOpaque = 'rgba(235, 239, 240, 0.12)'
const $grayBackgroundMediumOpaque = 'rgba(235, 239, 240, 0.36)'
const $grayLightest = '#f9f9f9'

export const useEvidencePageStyles = makeStyles({
    header: {
        padding: `${getPixelInREM(4)} 0`,
        marginBottom: getPixelInREM(15)
    },
    headerRow: {
        width: '100%',
        paddingRight: getPixelInREM(12),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
})

export const useEvidenceListStyles = makeStyles((theme) => ({
    listContainer: {
        padding: `${getPixelInREM(24)} 0 ${getPixelInREM(24)} 0`
    },
    evidenceListHeader: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: `5px 5px 0 0`,
        boxShadow: `0 -2px 10px 0 ${$grayBackgroundDarkOpaque}`,
        padding: `${getPixelInREM(10)} ${getPixelInREM(14)}`,
        fontSize: getPixelInREM(20),
        fontWeight: 600,
        zIndex: 2,
        color: theme.palette.primary.main,
        '& .negative': {
            color: theme.palette.error.main
        }
    },
    title: {
        flex: 1
    },
    listCounter: {
        position: 'relative',
        bottom: getPixelInREM(2),
        height: getPixelInREM(18),
        padding: `${getPixelInREM(2)} ${getPixelInREM(6)} ${getPixelInREM(
            2
        )} ${getPixelInREM(6)}`,
        margin: `0 ${getPixelInREM(8)}`,
        borderRadius: 4,
        background: theme.palette.primary.main,
        color: 'white',
        fontSize: getPixelInREM(11),
        '&.negative': {
            backgroundColor: theme.palette.error.main
        }
    },
    evidenceListContent: {
        background: $grayLightest,
        width: '100%',
        padding: `0 ${getPixelInREM(8)}`,
        paddingTop: getPixelInREM(10)
    },
    evidenceListShowAllButton: {
        width: getPixelInREM(135),
        textTransform: 'none',
        padding: `${getPixelInREM(12)} ${getPixelInREM(8)} ${getPixelInREM(12)}`
    },
    evidenceFilterBarContainer: {
        marginRight: getPixelInREM(10)
    }
}))

export const useEvidenceItemStyles = makeStyles((theme) => ({
    item: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: getPixelInREM(45),
        backgroundColor: 'white',
        borderLeft: `5px solid ${theme.palette.primary.main}`,
        boxShadow: `0 -2px 10px 0 ${$grayBackgroundDarkOpaque}`,
        alignItems: 'center',
        padding: `0 ${getPixelInREM(14)}`,
        marginBottom: getPixelInREM(10),
        borderRadius: 5,
        fontSize: getPixelInREM(18),
        fontWeight: 600,
        cursor: 'pointer',
        justifyContent: 'space-between',
        '&.open': {
            marginBottom: 0,
            borderRadius: '5px 5px 0 0'
        },

        '&.negative': {
            borderColor: theme.palette.error.main
        },

        '&.open.negative': {
            marginBottom: 0,
            borderRadius: '5px 5px 0 0',
            borderColor: theme.palette.error.main
        }
    },
    title: {
        paddingBottom: getPixelInREM(10),
        paddingRight: getPixelInREM(20),
        width: '100%'
    },
    iconWrapper: {
        width: 30,
        height: 30,
        marginRight: getPixelInREM(10),
        '& .MuiIconButton-label': {
            paddingBottom: getPixelInREM(10)
        }
    },
    score: {
        paddingLeft: getPixelInREM(10)
    },
    details: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '0 0 5px 5px',
        borderLeft: `5px solid ${theme.palette.primary.main}`,
        alignItems: 'center',
        padding: `0 ${getPixelInREM(4)}`,
        fontSize: getPixelInREM(14),
        marginBottom: getPixelInREM(10),
        fontWeight: 600,
        '&.open': {
            marginBottom: getPixelInREM(10)
        },

        '&.negative': {
            borderLeft: `5px solid ${theme.palette.error.main}`
        }
    },
    row: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: $grayBackgroundLightOpaque,
        '&.dark': {
            backgroundColor: $grayBackgroundMediumOpaque
        },
        '&:last-of-type': {
            marginBottom: getPixelInREM(5)
        }
    },
    boxContent: {
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
    },
    genomateScore: {
        position: 'relative',
        display: 'flex',
        margin: `0 ${getPixelInREM(10)} 0 0`
    }
}))
